<template>
  <div class="df ">
    <depart-tree @select="select"></depart-tree>
    <div class="f1" style="overflow:auto; ">
      <a-table
        rowKey="id"
        :dataSource="list"
        :columns="columns"
        class="mb20"
        size="small"
        :scroll="{
          x: 950
        }"
        :pagination="tablePagination"
        :row-selection="{
          selectedRowKeys: selectedRowKeys,
          onChange: onSelectChange
        }"
        ref="tableRef"
      >
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'deal'">
            <a-button type="link" @click="modalState.onVisible(record.id)"
              >详情</a-button
            >
            <AssignAuth
              :systems="data.selectOptions"
              text="分配"
              :id="record.id"
            />
          </template>
        </template>
      </a-table>
    </div>
  </div>
  <DetailModal />
</template>
<script>
import { message } from 'ant-design-vue'
import { toRefs, reactive, provide, inject } from 'vue'
import { roles } from 'server/modules/ssoApi.js'
import DetailModal from './DetailModal'
import AssignAuth from './AssignAuth'
import DepartTree from './DepartTree'
import { user_query_role_id_get, common_info_get } from 'server/modules/351.js'

export default {
  components: {
    DepartTree,
    DetailModal,
    AssignAuth
  },
  setup() {
    const state = inject('state')
    const modalState = reactive({
      visible: false,
      tableData: [],
      rowId: '',
      onVisible(id) {
        modalState.rowId = id
        user_query_role_id_get({ id })
          .then(res => {
            modalState.tableData = res.data.list
            modalState.visible = true
          })
          .catch(() => {})
      },
      handleOk() {
        modalState.visible = false
      },
      fetchBase() {
        common_info_get()
          .then(res => {
            state.roles = res.data.role
            data.selectOptions = res.data
          })
          .catch(() => {})
      }
    })
    const data = reactive({
      selectOptions: {}
    })
    modalState.fetchBase()
    provide('modalState', modalState)

    const detailState = reactive({
      // 模拟v-model radio
      changeChecks: (e, name) => {
        detailState[name] = [...e]
      },
      // 查询角色权限
      getRoles: async (params, title) => {
        const { setAttrs, systemId } = state
        if (systemId === -1) {
          message.warning('请选择一个系统！')
          return
        }
        const { id } = params

        const { success, data } = await roles({
          userId: id,
          systemId
        })
        if (success) {
          const { list } = data
          setAttrs('userId', id)
          setAttrs('roles', list)
          setAttrs('title', title)
          setAttrs('visible', true)
        }
      },
      removeParams: name => {
        let empParams = []
        detailState[name].map(v => {
          if (!v.checkStatus) {
            empParams.push(v)
          }
        })
        detailState[name] = empParams
      }
    })
    const onSelectChange = (selectedRowKeys, selectedRows) => {
      state.selectedRowKeys = selectedRows.map(v => v.id)
      console.log(selectedRowKeys, selectedRows)
      console.log(state.selectedRowKeys)
    }
    const select = val => {
      state.tablePagination.current = 1
      state.departmentId = val[0]
      state.initData()
    }

    provide('detailState', detailState)

    return {
      select,
      ...toRefs(detailState),
      ...toRefs(state),
      modalState,
      data,
      onSelectChange,
      columns: [
        {
          title: 'ID',
          dataIndex: 'id',
          key: 'id'
        },
        {
          title: '姓名',
          dataIndex: 'name',
          key: 'name',
          width: 150,
          align: 'center'
        },
        {
          title: '邮箱',
          dataIndex: 'email',
          key: 'email',
          width: 200
        },
        {
          title: '职位信息',
          dataIndex: 'title',
          key: 'title',
          width: 200
        },
        {
          title: '员工编号',
          dataIndex: 'jobNumber',
          key: 'jobNumber',
          with: 150
        },

        {
          title: '操作',
          key: 'deal',
          fixed: 'right',
          align: 'center',
          width: 150
        }
      ]
    }
  }
}
</script>
<style lang="scss" scoped>
.f1 {
  flex: 1;
}
</style>
